/*
 * @Author: cc
 * @Date: 2020-01-17 17:18:38
 * @LastEditTime: 2021-03-26 09:47:59
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\IM\chatTipBar\chatTipBar.js
 * @Description:
 */
angular.module('chatTipBarModule', ['CTBDrapDownListModule', 'imStarterModule']).directive('chatTipBar', [
    'messagePublishService',
    'imStarter',
    '$modal',
    'publicToolService',
    function(messagePublishService, imStarter, $modal, publicToolService) {
        return {
            restrict: 'E',
            replace: false,
            scope: {},
            templateUrl: './IM/chatTipBar/chatTipBar_tpl.html',
            link(scope) {
                initStatus();

                /**
                 * [initStatus description] 初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    scope.loaders = imStarter.start();
                    publicToolService.getModeconfiguration('IM').then((config) => {
                        scope.imConfig = config;
                    });
                    scope.$root.imChatList = [];
                }

                /**
                 * [im description] 打开im聊天
                 * @return {[type]} [description]
                 */
                scope.im = function() {
                    scope[scope.imConfig.mode]();
                };

                /**
                 * [general description] 通用方式
                 * @return  {[type]}  [return description]
                 */
                scope.general = function () {
                    $modal.open({
                        templateUrl: './IM/directive/tencentIm/index.html',
                        windowClass: 'tencent-im-modal',
                        backdrop: false,
                        controller: 'tencentImCtrl'
                    });
                };

                /**
                 * [jiuzhou description] 九州（）
                 * @return  {[type]}  [return description]
                 */
                scope.jiuzhou = function (){
                    window.open('http://172.16.24.10:9090/ocssso/login.jsp'); // 这次就换的很合理
                };

                /**
                 * [goToChat description] 打开指定聊天
                 * @param  {[type]} item [description] 指定聊天
                 * @return {[type]}      [description]
                 */
                scope.goToChat = function(item) {
                    scope.$root.chatWindowSwitch = true;
                    scope.$root.$broadcast('goToTheChart', item);
                };

                /**
                 * [imChart description] 打开im并进入指定聊天人员界面
                 * @return {[type]} [description]
                 */
                scope.imChart = function() {
                    scope.$root.chatWindowSwitch = true;
                    scope.$root.$broadcast('goToTheChart', scope.$root.imChatList[0]);
                };
            },
        };
    },
]);
